module.exports = __webpack_public_path__ + "img/21.0022e4b6.jpg";